/* Norrviva — swatch → tile image + link hover-swap (SHARED).
 *
 * Progressive enhancement for any tile marked [data-swatch-tile] that
 * contains:
 *   - an image wrapper [data-tile-img] holding one <img>
 *   - one or more tile links [data-tile-link] (href updated on hover)
 *   - colourway swatch links .nvv-swatch[data-url] (optionally with
 *     [data-swap-img] = that colourway's hero)
 *
 * On desktop, hovering a swatch swaps the tile's main image to that
 * colourway's hero AND points the tile image/name links at that
 * colourway's PDP. The swap STICKS — it stays on the last-hovered colourway
 * and only changes when another swatch is hovered (no revert on mouse-leave).
 * With no JS (or on touch), the swatches are already real PDP links and the
 * tile points at the featured colourway — nothing breaks, you just lose the
 * live preview.
 *
 * Used by the megamenu and the homepage patterns grid.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  function initTile(tile) {
    var img = tile.querySelector('[data-tile-img] img');
    var links = tile.querySelectorAll('[data-tile-link]');
    var swatches = tile.querySelectorAll('.nvv-swatch[data-url]');
    var cwLabel = tile.querySelector('[data-tile-cw-label]');
    if (!img || !swatches.length) return;

    var origSrc = null, origSrcset = null, origCw = null;
    var origHrefs = [];
    var preloaded = false;

    function save() {
      if (origSrc !== null) return;
      origSrc = img.getAttribute('src') || '';
      origSrcset = img.getAttribute('srcset') || '';
      if (cwLabel) origCw = cwLabel.textContent;
      links.forEach(function (a) { origHrefs.push(a.getAttribute('href') || ''); });
    }

    function preload() {
      if (preloaded) return;
      preloaded = true;
      swatches.forEach(function (sw) {
        var u = sw.getAttribute('data-swap-img');
        if (u) { var pre = new Image(); pre.src = u; }
      });
    }

    function restore() {
      if (origSrc === null) return;
      img.setAttribute('srcset', origSrcset);
      img.setAttribute('src', origSrc);
      if (cwLabel && origCw !== null) cwLabel.textContent = origCw;
      links.forEach(function (a, i) { a.setAttribute('href', origHrefs[i]); });
    }

    tile.addEventListener('mouseenter', preload);
    /* No mouseleave-restore: the hovered colourway STAYS until another swatch
       is hovered (sticky preview, per founder request). `restore` is kept for
       reference but no longer wired up. */
    void restore;

    swatches.forEach(function (sw) {
      sw.addEventListener('mouseenter', function () {
        save();
        var hero = sw.getAttribute('data-swap-img');
        if (hero) { img.setAttribute('srcset', ''); img.setAttribute('src', hero); }
        var url = sw.getAttribute('data-url');
        if (url) { links.forEach(function (a) { a.setAttribute('href', url); }); }
        var cw = sw.getAttribute('data-cw');
        if (cwLabel && cw) cwLabel.textContent = cw;
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-swatch-tile]').forEach(initTile);
  });
})();
